<template>
    <div class="criar-campo-formulario">
        <Accordion>
            <AccordionTab header="Design da Página">
                <div class="conteudo-wrapper">
                    <GrupoDeBotoes :opcoes="categorias" v-model="categoriaSelecionada" />
                </div>

                <Divider />

                <div v-if="categoriaSelecionada != null" class="conteudo-wrapper">
                    <div key="tipografia" v-if="categoriaSelecionada === 'tipografia'" style="display: flex; flex-direction: column; gap: 8px">
                        <h2 style="font-size: 1rem; margin-bottom: 0px">Editar Tipografia</h2>
                        <label style="display: flex; flex-direction: column; gap: 4px">
                            Tipografia
                            <Dropdown v-model="fonte" :options="fonts" class="w-full" />
                        </label>
                        <label style="display: flex; flex-direction: column; gap: 4px">
                            Peso da Fonte
                            <Dropdown v-model="pesoFonte" :options="pesos" optionLabel="rotulo" optionValue="valor" class="w-full" />
                        </label>
                    </div>

                    <div key="fundo" v-if="categoriaSelecionada === 'fundo'" style="display: flex; flex-direction: column; gap: 8px">
                        <h2 style="font-size: 1rem; margin-bottom: 0px">Editar Preenchimento de Fundo</h2>
                        <label style="display: flex; flex-direction: column; gap: 4px">
                            Preenchimento
                            <Dropdown
                                v-model="preenchimentoSelecionado"
                                @update:modelValue="limparFundo"
                                :options="preenchimentos"
                                optionLabel="rotulo"
                                optionValue="valor"
                                class="w-full"
                            />
                        </label>

                        <label v-if="preenchimentoSelecionado === 'cor'" style="display: flex; flex-direction: column; gap: 4px">
                            Cor de Fundo
                            <div class="color-input-container">
                                <input v-model="corFundo" type="color" class="color-input" />
                                <InputText v-model="corFundo" type="text" class="color-text" placeholder="#ffffff" />
                            </div>
                        </label>

                        <div v-if="preenchimentoSelecionado === 'imagem'" class="form-group">
                            <label>Selecionar Imagem</label>
                            <div class="image-upload-container">
                                <input type="file" ref="fileInput" @change="handleImageUpload" accept="image/*" style="display: none" />
                                <div class="image-display" @click="$refs.fileInput.click()">
                                    <span v-if="!imagemFundo" class="image-placeholder">
                                        {{ nomeImagem || 'Imagem.png' }}
                                    </span>
                                    <img v-else :src="imagemFundo" alt="Preview" class="image-preview" />
                                    <div class="image-actions">
                                        <button v-if="imagemFundo" type="button" class="image-remove-btn" @click.stop="removerImagem" title="Remover imagem">
                                            <span class="material-symbols-outlined">close</span>
                                        </button>
                                        <button type="button" class="image-upload-btn">
                                            <span class="material-symbols-outlined">upload</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div key="layout" v-if="categoriaSelecionada === 'layout'" style="display: flex; flex-direction: column; gap: 8px">
                        <h2 style="font-size: 1rem; margin-bottom: 0px">Editar Layout</h2>
                        <label style="display: flex; flex-direction: column; gap: 6px">
                            Margem Horizontal
                            <InputNumber v-model="paddingHorizontal" :min="0" :max="50" />
                            <Slider :max="50" v-model="paddingHorizontal" />
                        </label>
                        <label style="display: flex; flex-direction: column; gap: 6px">
                            Margem Vertical
                            <InputNumber v-model="paddingVertical" :min="0" :max="50" />
                            <Slider :max="50" v-model="paddingVertical" />
                        </label>
                    </div>
                </div>
                <Divider v-if="categoriaSelecionada != null" />
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import GrupoDeBotoes from '@/components/editorLandingPage/ui/GrupoDeBotoes.vue';
import { usePersonalizarPagina } from '@/composables/usePersonalizarPagina';

const { fonte, pesoFonte, corFundo, imagemFundo, limparFundo, paddingVertical, paddingHorizontal } = usePersonalizarPagina();

const categorias = [
    { rotulo: 'Tipografia', valor: 'tipografia', icone: 'brand_family' },
    { rotulo: 'Fundo da Página', valor: 'fundo', icone: 'wallpaper' },
    { rotulo: 'Layout', valor: 'layout', icone: 'responsive_layout' },
];
const categoriaSelecionada = ref();

const preenchimentos = [
    { rotulo: 'Imagem', valor: 'imagem' },
    { rotulo: 'Cor Sólida', valor: 'cor' },
];
const preenchimentoSelecionado = ref('cor');

const fonts = ['Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Roboto', 'Open Sans'];

const pesos = [
    { rotulo: 'Fino', valor: '100' },
    { rotulo: 'Extra Leve', valor: '200' },
    { rotulo: 'Leve', valor: '300' },
    { rotulo: 'Regular', valor: '400' },
    { rotulo: 'Médio', valor: '500' },
    { rotulo: 'Semi-negrito', valor: '600' },
    { rotulo: 'Negrito', valor: '700' },
    { rotulo: 'Extra-negrito', valor: '800' },
    { rotulo: 'Pesado', valor: '900' },
];

const fileInput = ref(null);
const nomeImagem = ref('Imagem.png');

function handleImageUpload(event) {
    const file = event.target.files[0];
    if (file) {
        nomeImagem.value = file.name;

        const reader = new FileReader();
        reader.onload = (e) => {
            imagemFundo.value = e.target.result;
        };
        reader.readAsDataURL(file);
    }
}

function removerImagem() {
    imagemFundo.value = null;
    nomeImagem.value = 'Imagem.png';

    if (fileInput.value) {
        fileInput.value.value = '';
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 16px;
}

.form-group label {
    display: block;
    font-size: 13px;
    color: #333;
    margin-bottom: 8px;
}

.image-upload-container {
    width: 100%;
}

.image-display {
    position: relative;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 8px;
    transition: all 0.2s ease;
}

.image-display:hover {
    border-color: #0f97c7;
}

.image-placeholder {
    color: #666;
    font-size: 14px;
}

.image-preview {
    max-width: 100px;
    max-height: 30px;
    object-fit: cover;
    border-radius: 4px;
}

.image-actions {
    display: flex;
    gap: 4px;
    align-items: center;
}

.image-upload-btn {
    background: none;
    border: none;
    color: #0f97c7;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-upload-btn:hover {
    background: rgba(15, 151, 199, 0.1);
}

.image-remove-btn {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.image-remove-btn:hover {
    background: rgba(220, 38, 38, 0.1);
}

.conteudo-wrapper {
    padding: 0 8px;
}

.color-input-container {
    display: flex;
    gap: 8px;
    align-items: center;
}

.color-input {
    width: 44px;
    height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 4px;
    cursor: pointer;
    background: none;
}

.color-text {
    flex: 1;
    box-sizing: border-box;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link) {
    background: #fff;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 8px;
    font-weight: normal;
    font-size: 14px;
    color: #252529;
    border-radius: 0;
    box-shadow: none;
    justify-content: space-between;
    width: 100%;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link .p-accordion-toggle-icon) {
    color: #0f97c7;
    order: 2;
    margin-left: auto;
    transition: transform 0.2s ease;
}

:deep(.p-accordion .p-accordion-header.p-highlight .p-accordion-header-link .p-accordion-toggle-icon) {
    transform: rotate(180deg);
}

:deep(.p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link) {
    background: #f8f9fa;
    color: #252529;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link:focus) {
    box-shadow: none;
    outline: none;
}

:deep(.p-accordion .p-accordion-header .p-accordion-header-link:hover) {
    background: #f8f9fa;
}

:deep(.p-accordion .p-accordion-content) {
    background: #fff;
    border: none;
    padding: 16px 0 8px 0;
    border-top: none;
}

:deep(.p-accordion) {
    border: none;
    box-shadow: none;
    width: 100%;
}

:deep(.p-accordion .p-accordion-tab) {
    border: none;
    margin-bottom: 0;
    width: 100%;
}

:deep(.p-accordion .p-accordion-header) {
    border: none;
    border-radius: 0;
    width: 100%;
}

:deep(.p-accordion .p-accordion-tab:not(:last-child)) {
    margin-bottom: 0;
}
</style>
